import { render, staticRenderFns } from "./ProcedureDomainIndex.vue?vue&type=template&id=0f4eef30&"
import script from "./ProcedureDomainIndex.vue?vue&type=script&lang=ts&"
export * from "./ProcedureDomainIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports